'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/account-routes.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _fca = require('@marmalade/footers/lib/fca');
var _fca2 = _interopRequireDefault(_fca);
var _standard = require('@marmalade/headers/lib/standard');
var _standard2 = _interopRequireDefault(_standard);
var _isInternal = require('@marmalade/is-internal');
var _propTypes = require('@marmalade/prop-types');
var _themes = require('@marmalade/themes');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _selectors = require('../selectors');
var _adminLogin = require('./admin-login');
var _adminLogin2 = _interopRequireDefault(_adminLogin);
var _changePasswordComplete = require('./change-password-complete');
var _changePasswordComplete2 = _interopRequireDefault(_changePasswordComplete);
var _changePasswordForm = require('./change-password-form');
var _changePasswordForm2 = _interopRequireDefault(_changePasswordForm);
var _chooseAPasswordForm = require('./choose-a-password-form');
var _chooseAPasswordForm2 = _interopRequireDefault(_chooseAPasswordForm);
var _loginForm = require('./login-form');
var _loginForm2 = _interopRequireDefault(_loginForm);
var _privateRoute = require('./private-route');
var _privateRoute2 = _interopRequireDefault(_privateRoute);
var _resetPasswordForm = require('./reset-password-form');
var _resetPasswordForm2 = _interopRequireDefault(_resetPasswordForm);
var _thirdpartyLoginForm = require('./thirdparty-login-form');
var _thirdpartyLoginForm2 = _interopRequireDefault(_thirdpartyLoginForm);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var _componentThemes$foot = _themes.componentThemes.footer,
  footerStyle = _componentThemes$foot.footerStyle,
  footerTheme = _componentThemes$foot.footerTheme;

/* eslint react/jsx-no-bind: 0 */

var AccountRoutes = function (_Component) {
  _inherits(AccountRoutes, _Component);
  function AccountRoutes() {
    _classCallCheck(this, AccountRoutes);
    return _possibleConstructorReturn(this, (AccountRoutes.__proto__ || Object.getPrototypeOf(AccountRoutes)).apply(this, arguments));
  }
  _createClass(AccountRoutes, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var props = this.props;
      var d = new Date();
      var year = d.getFullYear();
      var theme = footerTheme(props.theme);
      var poweredBy = theme[footerStyle('poweredBy')];
      var logo = poweredBy === true || poweredBy === 'dark' ? theme[footerStyle('marmLogoDark')] : undefined;
      var adminIFrame = this.props.internalUser && window !== window.parent;
      return _react2.default.createElement(_glamorous2.default.Div, {
        css: {
          backgroundColor: props.theme.colorOffWhite,
          overflowY: 'scroll',
          position: 'fixed',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44
        },
        __self: this
      }, _react2.default.createElement(_glamorous2.default.Div, {
        css: {
          display: 'flex',
          flexFlow: 'column nowrap',
          minHeight: '100%',
          paddingBottom: props.theme.space_md
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55
        },
        __self: this
      }, props.product !== 'admin' && !adminIFrame ? _react2.default.createElement(_standard2.default, {
        id: 'headerWrapper',
        noLiveChat: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63
        },
        __self: this
      }) : null, _react2.default.createElement(_glamorous2.default.Div, {
        css: {
          flexGrow: 1
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 64
        },
        __self: this
      }, _react2.default.createElement(_reactRouterDom.Switch, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65
        },
        __self: this
      }, _react2.default.createElement(_reactRouterDom.Route, {
        path: '/login',
        exact: true,
        render: function render() {
          return _react2.default.createElement(_loginForm2.default, {
            product: props.product,
            redirect: props.accountHomeLink,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 69
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        },
        __self: this
      }), props.product === 'ldi' && _react2.default.createElement(_reactRouterDom.Route, {
        path: '/thirdparty-login',
        exact: true,
        render: function render() {
          return _react2.default.createElement(_thirdpartyLoginForm2.default, {
            product: props.product,
            redirect: props.accountHomeLink,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 76
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        },
        __self: this
      }), props.product === 'ldi' && _react2.default.createElement(_reactRouterDom.Route, {
        path: '/admin-login',
        exact: true,
        render: function render() {
          return _react2.default.createElement(_adminLogin2.default, {
            product: props.product,
            redirect: props.accountHomeLink,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 85
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Route, {
        path: '/reset-password',
        exact: true,
        render: function render() {
          return _react2.default.createElement(_resetPasswordForm2.default, {
            product: props.product,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 92
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 89
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Route, {
        path: '/choose-a-password',
        exact: true,
        render: function render() {
          return _react2.default.createElement(_chooseAPasswordForm2.default, {
            product: props.product,
            redirect: props.accountHomeLink,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 98
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 94
        },
        __self: this
      }), _react2.default.createElement(_privateRoute2.default, {
        path: '/change-password',
        exact: true,
        render: function render() {
          return _react2.default.createElement(_changePasswordForm2.default, {
            product: props.product,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 104
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 101
        },
        __self: this
      }), _react2.default.createElement(_privateRoute2.default, {
        path: '/change-password-complete',
        exact: true,
        render: function render() {
          return _react2.default.createElement(_changePasswordComplete2.default, {
            product: props.product,
            redirect: props.accountHomeLink,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 110
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 106
        },
        __self: this
      }))), props.product !== 'admin' && !adminIFrame ? _react2.default.createElement('div', {
        id: 'footerWrapper',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 116
        },
        __self: this
      }, props.isLoggedIn ? _react2.default.createElement(_fca2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118
        },
        __self: this
      }) : _react2.default.createElement(_glamorous2.default.Footer, {
        css: {
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120
        },
        __self: this
      }, poweredBy && _react2.default.createElement('span', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 123
        },
        __self: this
      }, 'Powered by'), logo ? _react2.default.createElement(_glamorous2.default.Img, {
        src: logo,
        maxHeight: '70px',
        display: 'block',
        maxWidth: '200px',
        margin: '0 0 5px',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125
        },
        __self: this
      }) : _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 133
        },
        __self: this
      }, _react2.default.createElement('div', {
        id: 'update-cookie-preferences-container',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 134
        },
        __self: this
      }), _react2.default.createElement('span', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 135
        },
        __self: this
      }, '\xA9 ', year, ' Marmalade All Rights Reserved.')))) : null));
    }
  }]);
  return AccountRoutes;
}(_react.Component);
AccountRoutes.propTypes = {
  product: _propTypes.product.isRequired,
  accountHomeLink: _propTypes2.string.isRequired,
  isLoggedIn: _propTypes2.bool.isRequired,
  internalUser: _propTypes2.bool.isRequired,
  theme: _propTypes2.object.isRequired
};
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    isLoggedIn: (0, _selectors.isLoggedIn)(state),
    internalUser: (0, _isInternal.isInternal)(state)
  };
})((0, _glamorous.withTheme)(AccountRoutes));